/**
* This file is loaded asyncronously in the footer.
* All custom global scripts should be included here.
*/

	/*
	A little info for this js file:

	As much as possible, this file should be kept organized. Currently, two major divisions are seen below, delinitated by their respective functions of "on load" and "ready".
		As mentioned below, most code added to this file should be included within the "on load" function.

	For ease of future use, include any new code at the bottom of the relevant section of the page, adding clear comments to explain the purpose of the code being written,
		including any relavant details regarding what the code overrides, etc.
	*/


(function(){
	'use strict';

	// rerun lazyload on screen size updates
	window.addEventListener( 'resize', function() {
		dbs.lazyload();
	});

	// Load event function ... most custom stuff goes here. Safer for async.
	window.addEventListener( 'load', function() {
		/* Search Form functionality
		 * The click functionality involves three different actions,
		 * depending on conditions the various clicks provide.
		 */
		var searchOpen = document.querySelectorAll( '.search-form__button--open' );
		var searchClose = document.querySelectorAll( '.search-form__button--close' );

		if ( searchOpen ) {
			for (var i=0; searchOpen.length > i; i++) {
				searchOpen[i].addEventListener( 'click', function() {
					this.parentElement.classList.add( 'search-form--active' );
					this.parentElement.querySelector('.site_search__field').focus();
		
					// Hide the search bar after click out of it
					document.getElementById( 'content' ).addEventListener( 'click', function() {
						if ( this.parentElement.classList.contains( 'search-form--active' ) ) {
							this.parentElement.classList.remove( 'search-form--active' );
						}
					});
				});
			}
			
			for (var i=0; searchClose.length > i; i++) {
				searchClose[i].addEventListener( 'click', function() {
					this.parentElement.classList.remove( 'search-form--active' );
				});
			}
		}


		/**
		 * Linkclicker
		 * 
		 * A class placed on a wrapping element with a link inside to make the wrapper clickable.
		 * Note: the container should have only one link.
		 */
		var linkclickers = document.querySelectorAll('.linkclicker');

		for ( var i = 0; linkclickers.length > i; i++ ) {
			var linkclicker = linkclickers[i];

			linkclicker.addEventListener('click', function(e) {
				e.preventDefault();
				var link = this.querySelector('a');
				var linkPath = link.getAttribute('href');
				
				if ( link.getAttribute('target', "_blank") ) {
					window.open(linkPath);
				} else {
					window.location.href = linkPath;
				}
			});
		}


		/**
		 * Force external links/PDFs to open in a new tab.
		 * From https://stackoverflow.com/questions/2910946/test-if-links-are-external-with-jquery-javascript
		 * 2019-07-11 - TA
		 */
		function link_is_external(link_element) {
			return ( link_element.host !== window.location.host || link_element.href.indexOf("pdf") > -1 );
		}

		var anchorElements = document.getElementsByTagName('a');
		for ( let anchorElement of anchorElements ) {

			if ( link_is_external( anchorElement ) ) {
				anchorElement.setAttribute( 'target','_blank' );
				anchorElement.setAttribute( 'rel','noopener' );

				// Add assistive text to alert of external links
				var assistiveText = '<span class="assistive">. External Link. Opens in new window.</span>';
				var assistiveTextContainer = document.createElement( 'span' );
				assistiveTextContainer.innerHTML = assistiveText;
				anchorElement.appendChild( assistiveTextContainer.firstChild );
			}
		}

		/**
		 * Detects if element is in viewport
		 * 
		 * @usage
		 * var el = document.querySelector('.element-class');
		 *
		 * window.addEventListener('scroll', function(event) {
		 * 		if (isInViewport(el)) {
		 *			el.classList.add("in-view");
		 *		}
		 * }, false);
		 * 
		 * NOTE: If the whole layout is taller than the viewport, this will never fire. It is often
		 * better to target one small element inside a layout.
		 */
		function isInViewport(elem) {
			var distance = elem.getBoundingClientRect();
			return (
				distance.top >= 0 &&
				distance.left >= 0 &&
				distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
				distance.right <= (window.innerWidth || document.documentElement.clientWidth)
			);
		};

		/**
		 * ANOTHER NOTE: Right now the idea is to use this as needed on certain layouts, rather 
		 * than querying all elements of a certain class globally and looping through them. 
		 * However, that is a reasonable approach if there is a significant amount of 
		 * scroll animations being done; especially if it's already on the home page. Here
		 * is an example of how that would be done.
		 */
		// var els = document.querySelectorAll('.animated');
		
		// for (let i = 0; els.length > i; i++) {
		// 	let _this = els[i];
		// 	window.addEventListener('scroll', function(event) {
		// 		if ( isInViewport(_this) ) {
		// 			_this.classList.add("in-view");
		// 		}
		// 	}, false);
		// }
        
        // If <ol class="steps"> exists, prepend <div class="marker"> onto each <li>
        const stepsLists = document.querySelectorAll('ol.steps');
        if (stepsLists.length > 0) {
            stepsLists.forEach(stepsList => {
                const lis = [...stepsList.children];
                lis.forEach(li => {
                    if (!li.querySelector('div.marker')) {
                        let marker = document.createElement('div');
                        marker.classList.add('marker');
                        marker.innerHTML = '&nbsp;';
                        li.prepend(marker);
                    }
                });
            });
        }
        
        const handshake = document.querySelector('.handshake');
        const handshakeImg = document.querySelector('.handshake img');
        if (handshake) {
            const resizeHandshake = function() {
                handshake.style.height = handshakeImg.offsetHeight + 'px';
            }
            window.addEventListener('resize', resizeHandshake);
            resizeHandshake();
        }

	}); // End of load function
	

	// Include ready events here
	window.addEventListener( 'DOMContentLoaded', function() {
		const phoneNumbers = []; // Store phone numbers in order
		const phoneRegex = /^\(?(\d{3})\)?[-.\s]?(?:\d{3})[-.\s]?\d{4}$/; // Basic phone format validation
		
		// Function to format phone number to xxx-xxx-xxxx
		function formatPhoneNumber(phoneNumber) {
		    // Remove all non-numeric characters
		    const digits = phoneNumber.replace(/\D/g, '');
		
		    // Format to xxx-xxx-xxxx
		    if (digits.length === 10) {
		        return digits.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
		    }
		    return phoneNumber; // If it's not a valid number, return original
		}
		
		
		document.querySelectorAll('[class$="-icon"]').forEach(icon => {
		    icon.addEventListener('click', function (e) {
		        const targetId = this.getAttribute('data-target');
		        
		        if (targetId === 'date' || targetId === 'rsvp-date') {                
		            console.log(targetId);
		            const input = document.getElementById(targetId);
		            if (input) {
		                input.showPicker();
		            }
		        } else if (targetId === 'time' || targetId === 'rsvp-time') {
		            e.srcElement.previousElementSibling.focus();
		        } else if (targetId === 'select') {
		            e.preventDefault();
		        } else if (targetId === 'tel') {
		            e.preventDefault();
		            
		            const telWrapper = this.closest('.tel-wrapper');
		            if (!telWrapper) return;
		
		            const input = telWrapper.querySelector('input[type="tel"]');
		            if (!input) return;
		
		            const phoneNumber = input.value.trim();
		            let errorDiv = telWrapper.querySelector('.error-message');
		
		            // Remove any previous error message
		            if (errorDiv) {
		                errorDiv.remove();
		            }
		
		            // Validate phone number
		            if (!phoneRegex.test(phoneNumber)) {
		                errorDiv = document.createElement('div');
		                errorDiv.className = 'error-message';
		                errorDiv.style.color = '#BF0404';
		                errorDiv.style.fontSize = '0.75rem';
		                errorDiv.style.marginTop = '5px';
		                errorDiv.textContent = 'Please enter a valid phone number.';
		                telWrapper.appendChild(errorDiv);
		                return; // Stop execution if invalid
		            }
		
		            // Format phone number to xxx-xxx-xxxx
		            const formattedPhoneNumber = formatPhoneNumber(phoneNumber);
		
		            // Add the formatted number to the list
		            phoneNumbers.push(formattedPhoneNumber);
		
		            // Create or update the list display
		            let phoneListDiv = document.getElementById('phone-list');
		            if (!phoneListDiv) {
		                phoneListDiv = document.createElement('div');
		                phoneListDiv.id = 'phone-list';
		                phoneListDiv.style.marginBottom = '0.5rem';
		                telWrapper.parentNode.insertBefore(phoneListDiv, telWrapper);
		            }
		
		            // Update list content
		            phoneListDiv.innerHTML = phoneNumbers
		                .map((number, index) => `<div>${index + 1}. ${number}</div>`)
		                .join('');
		
		            // Clear input
		            input.value = '';
		
		            // Push tel-wrapper down slightly
		            telWrapper.style.marginTop = '0.5rem';
		        }
		    });
		});
		
		const params = new URLSearchParams(window.location.search);
		const response = params.get("response");
		
		const responseText = document.getElementById("response-text");
		
		if (response === "agree") {
		    responseText.textContent = "agreed to";
		} else if (response === "decline") {
		    responseText.textContent = "declined";
		}
		
		const contractOptions = document.querySelectorAll('#contract input[type="radio"]');
		
		contractOptions.forEach(option => {
		    option.addEventListener('change', function (e) {
		        contractOptions.forEach(radio => {
		            if (radio.checked) {
		                radio.parentElement.style.backgroundColor = '#efece0'; // Selected
		            } else {
		                radio.parentElement.style.backgroundColor = '#F7F6F0'; // Not selected
		            }
		        });
		    });
		});
		
		/* Menu */
		const menuBtn = document.querySelector('.menu-btn');
		const closeBtn = document.querySelector('.close-btn');
		const menu = document.querySelector('.menu');
		const listItems = document.querySelectorAll('.menu ul li');
		
		if (menuBtn) {        
		    menuBtn.addEventListener('click', function (e) {
		        e.preventDefault();
		        menuBtn.style.display = 'none';
		        closeBtn.style.display = 'block';
		        listItems.forEach((li) => {
		            li.style.opacity = 1;
		        });
		        menu.classList.add('open');
		
		        const viewportHeight = window.innerHeight;
		        menu.style.maxHeight = `${viewportHeight}px`;
		        menu.style.minHeight = `${viewportHeight}px`;
		    });
		}
		
		if (closeBtn) {        
		    closeBtn.addEventListener('click', function (e) {
		        e.preventDefault();
		        closeBtn.style.display = 'none';
		        menuBtn.style.display = 'block';
		        listItems.forEach((li) => {
		            li.style.opacity = 0;
		        });
		        menu.classList.remove('open');
		
		        menu.style.maxHeight = '0';
		        menu.style.minHeight = '0';
		    });
		}
		
		window.addEventListener('resize', function() {
		    if (menu.classList.contains('open')) {            
		        const viewportHeight = window.innerHeight;
		        menu.style.maxHeight = `${viewportHeight}px`;
		        menu.style.minHeight = `${viewportHeight}px`;
		    }
		});
		
		const inputs = document.querySelectorAll('.main .field-wrapper input');
		let isCreateAcctPage = false;
		if (document.body.firstElementChild.nextElementSibling.classList.contains('create-acct')) {
		    isCreateAcctPage = true;
		}
		
		let labelTransformDefault = '';
		let labelTransformTel = '';
		
		const inputDefault = document.querySelector('.main .field-wrapper input');
		if (inputDefault) {
		    const labelDefault = inputDefault.parentElement.querySelector('label');
		    labelTransformDefault = window.getComputedStyle(labelDefault).transform;
		}
		
		const inputTel = document.querySelector('.main .field-wrapper input[type="tel"]');
		if (inputTel) {
		    const labelTel = inputTel.parentElement.querySelector('label');
		    labelTransformTel = window.getComputedStyle(labelTel).transform;
		}
		
		inputs.forEach((input) => {
		    const label = input.parentElement.querySelector('label');
		    
		    // when selecting an input field
		    input.addEventListener('focus', () => {
		        // if it is a phone field
		        if (input.type === 'tel') {
		            label.style.transform = 'translate(0, -2.975rem)';
		        // if it is not a phone field
		        } else {
		            label.style.transform = 'translate(0, -2.4rem)';
		        }
		        
		        // if it is on the Create an Account page (labels are small and gray to start)
		        if (isCreateAcctPage) {
		            label.style.color = '#2d2d2d';
		            label.style.fontSize = '1rem';
		        }
		    });
		    
		    // when clicking away from an input field
		    input.addEventListener('blur', () => {
		        // if the field is empty
		        if (input.value === '') {
		            // if it is a phone field
		            if (input.type === 'tel') {                
		                label.style.transform = labelTransformTel;
		            // if it is not a phone field
		            } else {
		                label.style.transform = labelTransformDefault;
		            }
		            
		            // if it is on the Create an Account page (labels are small and gray to start)
		            if (isCreateAcctPage) {
		                label.style.color = '#8A8B8C';
		                label.style.fontSize = '.875rem';
		            }
		        } 
		    });
		});
		
		const showPassBtn = document.getElementById('showPassBtn');
		const showPassBtn2 = document.getElementById('showPassBtn-2');
		const hidePassBtn = document.getElementById('hidePassBtn');
		const hidePassBtn2 = document.getElementById('hidePassBtn-2');
		const input = document.querySelector('.main .field-wrapper input#password');
		const input2 = document.querySelector('.main .field-wrapper input#password_confirmation');
		
		if (showPassBtn) {        
		    showPassBtn.addEventListener('click', function() {
		        input.type = 'text';
		        showPassBtn.style.opacity = 0;
		        showPassBtn.style.zIndex = 0;
		        hidePassBtn.style.opacity = 1;
		        hidePassBtn.style.zIndex = 1;
		    });
		}
		
		if (hidePassBtn) {        
		    hidePassBtn.addEventListener('click', function() {
		        input.type = 'password';
		        showPassBtn.style.opacity = 1;
		        showPassBtn.style.zIndex = 1;
		        hidePassBtn.style.opacity = 0;
		        hidePassBtn.style.zIndex = 0;
		    });
		}

		if (showPassBtn2) {        
		    showPassBtn2.addEventListener('click', function() {
		        input2.type = 'text';
		        showPassBtn2.style.opacity = 0;
		        showPassBtn2.style.zIndex = 0;
		        hidePassBtn2.style.opacity = 1;
		        hidePassBtn2.style.zIndex = 1;
		    });
		}
		
		if (hidePassBtn2) {        
		    hidePassBtn2.addEventListener('click', function() {
		        input2.type = 'password';
		        showPassBtn2.style.opacity = 1;
		        showPassBtn2.style.zIndex = 1;
		        hidePassBtn2.style.opacity = 0;
		        hidePassBtn2.style.zIndex = 0;
		    });
		}
	});


	/**
	 * Cookie Popup scripts
	 */
	var popUp		= document.getElementById('cookie-popup');
	var popUpMain	= document.getElementById('popup-main');

	// Hide popup and background filter and set cookie
	function accept() {
		popUp.style.display = "none";
		document.body.classList.add('cookies');
		setCookie( "accepts-cookie", "accepts-cookie-set", 365 );
	}

	document.getElementById('accept-button').addEventListener( 'click', function() {
		accept();
	});

	var cookie = readCookie( 'accepts-cookie' );
	// If user already has accepted cookies, don't show popup
	if ( cookie == 'accepts-cookie-set' ) {
		popUp.style.display = "none";
	} else {
		// Force screen reader to read popup
		popUpMain.setAttribute("aria-live", "assertive");
	}
})();
